<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" fill="none" viewBox="0 0 24 25">
  <path stroke="#000" d="M15.5 5.496l4 4m-2-6.5L2 18.496v4.5h4.5L22 7.496l-4.5-4.5z"/>
</svg>
